export enum ReportEnum {
    WORKER_LOAD = 'worker_load',
}
